import React from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import classnames from 'classnames';
import { withStyles } from '@glu/theming';
import { ActionableIcon, PencilIcon } from '@glu/icons-react';

import styles from './Toggle.styles';

const Toggle = ({ classes, onClick, className }) => (
  <div className={classnames(classes.root, className)}>
    <ActionableIcon
      className={classes.button}
      onClick={onClick}
    >
      <div className={classes.iconWrap}>
        <PencilIcon />
      </div>
      <p>{locale.get('branding.toggle')}</p>
    </ActionableIcon>
  </div>
);

Toggle.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

Toggle.defaultProps = {
  className: undefined
};

export default withStyles(styles)(Toggle);
